const uRLs = {
  AUTH_URL: process.env.REACT_APP_BASE_URL_AUTH_NEGOBILL_ADMIN,
  API_URL: process.env.REACT_APP_BASE_URL_API_NEGOBILL_ADMIN,

  SALE_BASE_URL: process.env.REACT_APP_BASE_URL_API_SALE_ADMIN,
  ENV_NAME:process.env.REACT_APP_ENV_NAME
 };

export default uRLs;
